// pages/download.js

import React from "react";

const Download = () => {
    return (
        <div
            style={{
                display: "flex",
                justifyContent: "centre",
                alignItems: "centre",
                height: "100vh",
            }}
        >
            <h1>
                Downloads
            </h1>
        </div>
    );
};

export default Download;
